import React from "react";
import { NavItem as BaseNavItem } from "reactstrap";
import { Trans } from "react-i18next";
import { NavLink } from "react-router-dom";

const NavItem = ({ to, children, exact, translate = true }) => (
  <BaseNavItem>
    <NavLink
      exact={exact}
      to={to}
      className="nav-link position-relative"
      activeClassName="active"
    >
      {translate ? <Trans>{children}</Trans> : children}
    </NavLink>
  </BaseNavItem>
);

export default NavItem;
